import { render } from "./LocalAudioControlButton.vue?vue&type=template&id=f4f0a068&scoped=true"
import script from "./LocalAudioControlButton.vue?vue&type=script&lang=js"
export * from "./LocalAudioControlButton.vue?vue&type=script&lang=js"

import "./LocalAudioControlButton.vue?vue&type=style&index=0&id=f4f0a068&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f4f0a068"]])

export default __exports__